import { FC, ReactNode } from 'react';

import { Box, Stack } from '@chakra-ui/react';

import { DashboardContainer } from './containers';
import { FooterNav } from './footer-nav';
import { PageLayout } from './page-layout';

export const SimplePageLayout: FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <PageLayout>
      <Box py={{ base: 8, lg: 16 }}>
        <DashboardContainer>
          <Stack gap={8}>
            <Box>
              {children}
              <Box h={8} />
              <FooterNav colorScheme='medium-gray' />
            </Box>
          </Stack>
        </DashboardContainer>
      </Box>
    </PageLayout>
  );
};
